module.exports = __webpack_public_path__ + "img/img6.c095b461.png";